import { SubheaderContainer } from './style';

interface SubHeaderProps {
  logo?: string | null;
  text?: string
}

const SubHeader = ({ logo, text }: SubHeaderProps) => {
  return (
    <SubheaderContainer>
      <p>{text}</p>
      {logo && (
        <button>
          <img src={logo}/>
        </button>
      )}
    </SubheaderContainer>
  )
}

export default SubHeader;